"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { EyeOff } from "lucide-react";
import styles from "./unpublishedCourseBadge.module.css";
const TOOLTIP = "This course is not ready for the public yet. Click to dismiss.";

/** Fixed badge shown when office IPs preview a course that is not public yet. */
export function UnpublishedCourseBadge() {
  const $ = _c(1);
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <button type="button" className={styles.badge} title={TOOLTIP} aria-label={TOOLTIP} onClick={() => setDismissed(true)}><EyeOff className={styles.icon} aria-hidden={true} /></button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}